import { render } from "./doubleSlider.vue?vue&type=template&id=54faff4a&scoped=true"
import script from "./doubleSlider.vue?vue&type=script&lang=js"
export * from "./doubleSlider.vue?vue&type=script&lang=js"

import "./doubleSlider.vue?vue&type=style&index=0&id=54faff4a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54faff4a"]])

export default __exports__